import { isInrCurrency } from './currency';

export function isINTaxExempt(data) {
  if (isInrCurrency()) {
    if (data?.taxpayer?.registration_type === 'Special Economic Zone' || data?.taxpayer?.registration_type === 'SEZ Developer') {
      return true;
    }
    return false;
  }
  return true;
}
